import { REHYDRATE } from 'redux-persist';
var initState = {
  setToken: '',
  getLoggedUserData: {},
  filters: {},
  CurrentUserData: {},
  appliedFilm: {
        category: [],
        genre: [],
        interestTrack: [],
        accessibility: [],
        GlobleSearch: '',
        startDate: '',
        endDate: '',
        startTime: '',
        endTime: ''
  },
  appliedBeyondFilm: {
        category: [],
        genre: [],
        interestTrack: [],
        accessibility: [],
        startDate: '',
        endDate: '',
        startTime: '',
        endTime: ''
    },
  appliedNewFrontier: {
        category: [],
        genre: [],
        interestTrack: [],
        accessibility: [],
        startDate: '',
        endDate: '',
        startTime: '',
        endTime: ''
  },
  appliedVenueFilter:{
        // city:[],
        // accessibility:[],
        // amenies:[]
        accessibility: [],
        accessibilityDescription: "",
        address: "",
        amenity: [],
        avaliableBusRoutes: "",
        city: [],
        createdAt: "",
        description: "",
        locations: [],
        name: "",
        operatingHrs: "",
        state: "",
        status: Number,
        street: "",
        updatedAt: "",
        updatedBy: "",
        zip: "",
        _id: "",

        },
  appliedFullVenues:[],
  timezone: '',
};

function sundanceReducer(state = initState, action) {
  switch (action.type) {
       
    case 'CurrentUserData':
        return {
            ...state,
            CurrentUserData: action.res,
        };
  
      case 'LogdedUserData':
          return {
              ...state,
              getLoggedUserData: action.res
          };
        case 'Filters':
            return {
                ...state,
                filters: action.res
            };

           

        case 'APPLIED_FILTERS_FILMS': {
            const appliedFilm = Object.assign({}, state.appliedFilm)
            if(action.payload.checked) {
                if(typeof appliedFilm[action.payload.filterType] !== 'object'){
                    appliedFilm[action.payload.filterType] = []    
                }
                appliedFilm[action.payload.filterType].push(action.payload.id)
            }else {
                appliedFilm[action.payload.filterType] = appliedFilm[action.payload.filterType].filter(e => e !== action.payload.id)
            }
            return {...state, appliedFilm};
        }
        case 'APPLIED_FILTERS_FILMS_DATE_TIME': {
            const appliedFilm = Object.assign({}, state.appliedFilm)
            appliedFilm[action.payload.name]=action.payload.date
            return {...state, appliedFilm};        
        }
        case 'CLEAR_FILMS_FILTERS': {
            var appliedFilm = Object.assign({}, state.appliedFilm)
            appliedFilm.category = []
            appliedFilm.genre = []
            appliedFilm.interestTrack = []
            appliedFilm.accessibility = []
            appliedFilm.startDate = ''
            appliedFilm.endDate = ''
            appliedFilm.startTime = ''
            appliedFilm.endTime = ''

            return {...state, appliedFilm};        
        }


        case 'APPLIED_FILTERS_BEYOND_THE_FILMS': {
            const appliedBeyondFilm = Object.assign({}, state.appliedBeyondFilm)
            if(action.payload.checked) {
                if(typeof appliedBeyondFilm[action.payload.filterType] !== 'object'){
                    appliedBeyondFilm[action.payload.filterType] = []    
                }
                appliedBeyondFilm[action.payload.filterType].push(action.payload.id)
            }else {
                appliedBeyondFilm[action.payload.filterType] = appliedBeyondFilm[action.payload.filterType].filter(e => e !== action.payload.id)
            }
            return {...state, appliedBeyondFilm};
        }
        case 'APPLIED_FILTERS_BEYOND_THE_FILMS_DATE_TIME': {
            const appliedBeyondFilm = Object.assign({}, state.appliedBeyondFilm)
            appliedBeyondFilm[action.payload.name]=action.payload.date
            return {...state, appliedBeyondFilm};        
        }
        case 'CLEAR_BEYOND_THE_FILMS_FILTERS': {
            var appliedBeyondFilm = Object.assign({}, state.appliedBeyondFilm)
            appliedBeyondFilm.category = []
            appliedBeyondFilm.genre = []
            appliedBeyondFilm.interestTrack = []
            appliedBeyondFilm.accessibility = []
            appliedBeyondFilm.startDate = ''
            appliedBeyondFilm.endDate = ''
            appliedBeyondFilm.startTime = ''
            appliedBeyondFilm.endTime = ''

            return {...state, appliedBeyondFilm};        
        }


        case 'APPLIED_FILTERS_NEW_FRONTIER': {
            const appliedNewFrontier = Object.assign({}, state.appliedNewFrontier)
            if(action.payload.checked) {
                if(typeof appliedNewFrontier[action.payload.filterType] !== 'object'){
                    appliedNewFrontier[action.payload.filterType] = []    
                }
                appliedNewFrontier[action.payload.filterType].push(action.payload.id)
            }else {
                appliedNewFrontier[action.payload.filterType] = appliedNewFrontier[action.payload.filterType].filter(e => e !== action.payload.id)
            }
            return {...state, appliedNewFrontier};
        }
        case 'APPLIED_FILTERS_NEW_FRONTIER_DATE_TIME': {
            const appliedNewFrontier = Object.assign({}, state.appliedNewFrontier)
            appliedNewFrontier[action.payload.name]=action.payload.date
            return {...state, appliedNewFrontier};        
        }
        case 'CLEAR_NEW_FRONTIER_FILTERS': {
            var appliedNewFrontier = Object.assign({}, state.appliedNewFrontier)
            appliedNewFrontier.category = []
            appliedNewFrontier.genre = []
            appliedNewFrontier.interestTrack = []
            appliedNewFrontier.accessibility = []
            appliedNewFrontier.startDate = ''
            appliedNewFrontier.endDate = ''
            appliedNewFrontier.startTime = ''
            appliedNewFrontier.endTime = ''

            return {...state, appliedNewFrontier};        
        }
        case 'GlobleSearch':
            return {
                ...state,
                GlobleSearch: action.payload,
            };


        case 'REMOVE_VENUES_FILTERS':{
            
            const appliedVenueFilter = Object.assign({}, state.appliedVenueFilter);
            // eslint-disable-next-line
           var appliedFullVenues = Object.assign([], state.appliedFullVenues);
           appliedVenueFilter[action.payload.filterType] = appliedVenueFilter[action.payload.filterType].filter(e => e !== action.payload.id);
           appliedFullVenues = appliedFullVenues.filter(e => e.id !== action.payload.id)
           return {...state, appliedVenueFilter, appliedFullVenues};
        }
        
        case 'CLEAR_VENUE_FILTERS' :{
            const appliedVenueFilter = Object.assign({}, state.appliedVenueFilter);
            var appliedFullVenues = Object.assign([], state.appliedFullVenues);
            appliedFullVenues=[]
            appliedVenueFilter.accessibility= [];
            appliedVenueFilter.accessibilityDescription= "";
            appliedVenueFilter.address= "";
            appliedVenueFilter.amenity= [];
            appliedVenueFilter.avaliableBusRoutes= "";
            appliedVenueFilter.city= [];
            appliedVenueFilter.createdAt= "";
            appliedVenueFilter.description= "";
            appliedVenueFilter.locations= [];
            appliedVenueFilter.name= "";
            appliedVenueFilter.operatingHrs= "";
            appliedVenueFilter.state= "";
            appliedVenueFilter.status= Number;
            appliedVenueFilter.street= "";
            appliedVenueFilter.updatedAt= "";
            appliedVenueFilter.updatedBy= "";
            appliedVenueFilter.zip= "";
            appliedVenueFilter._id= "";
            return {...state, appliedVenueFilter, appliedFullVenues};
        }

      case REHYDRATE:
          return {
              ...state,
              timezone:action.payload &&
              action.payload.timezone ? action.payload.timezone : '',  
                getLoggedUserData: action.payload &&
                    action.payload.getLoggedUserData ? action.payload.getLoggedUserData : {},
                filters: action.payload &&
                    action.payload.filters ? action.payload.filters : [],
                CurrentUserData: action.res &&
                    action.res.CurrentUserData ? action.res.CurrentUserData : [],
                appliedFilm:  {
                    category: [],
                    genre: [],
                    interestTrack: [],
                    accessibility: [],
                    startDate: '',
                    endDate: '',
                    startTime: '',
                    endTime: ''
                },
                appliedBeyondFilm: action.payload && action.payload.appliedBeyondFilm ? action.payload.appliedBeyondFilm : {
                    category: [],
                    genre: [],
                    interestTrack: [],
                    accessibility: [],
                    startDate: '',
                    endDate: '',
                    startTime: '',
                    endTime: ''
                },
                appliedNewFrontier: action.payload && action.payload.appliedNewFrontier ? action.payload.appliedNewFrontier : {
                    category: [],
                    genre: [],
                    interestTrack: [],
                    accessibility: [],
                    startDate: '',
                    endDate: '',
                    startTime: '',
                    endTime: ''
                },
                GlobleSearch: action.payload && action.payload.GlobleSearch ? action.payload.GlobleSearch : ''
          }

          case 'TIMEZONE':
            return {
                ...state,
                timezone: action.timezone
            }
          case 'APPLIED_FILTERS_VENUES': {
            const appliedVenueFilter = Object.assign({}, state.appliedVenueFilter);
            var appliedFullVenues = Object.assign([], state.appliedFullVenues);
            
            if (action.payload.checked) {
                if (typeof appliedVenueFilter[action.payload.filterType] !== 'object') {
                    appliedVenueFilter[action.payload.filterType] = [];
                }
                appliedVenueFilter[action.payload.filterType].push(action.payload.id);
                appliedFullVenues.push(action.payload);
            } else {
                appliedVenueFilter[action.payload.filterType] = appliedVenueFilter[action.payload.filterType].filter(e => e !== action.payload.id);
                appliedFullVenues = appliedFullVenues.filter(e => e.id !== action.payload.id)
            }
            // debugger
            return {...state, appliedVenueFilter, appliedFullVenues};
        }
      default:
          return {
              ...state
          }
  }
}

export const reducer = sundanceReducer;